import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { mapLoginResponse } from "@/redux/mappers/loginMappers";
import { apiurl } from "@/Config/ApiConfig/ApiUrl";

export const organizationApi = createApi({
  reducerPath: "organizationApi",
  baseQuery: fetchBaseQuery({ baseUrl: import.meta.env.VITE_BASE_API_URL }),
  tagTypes: ["Organization"],
  endpoints: (builder) => ({
    getOrganization: builder.query({
      query: () => apiurl.Organization,
      transformResponse: (response) => {
        // console.log(response.data, "response in redux");
        const dataArray = response?.data.organizations ?? [];
        return Array.isArray(dataArray) ? dataArray.map(mapLoginResponse) : [];
      },
      providesTags: ["Organization"],
    }),

    login: builder.mutation({
      query: ({ userName, userPassword, organizationId }) => ({
        url: "/login", 
        method: "POST",
        headers: {
          "X-Request-Id": Math.random().toString(36).substring(2), // or any unique id
        },
        body: {
          userName,
          userPassword,
          organizationId,
        },
      }),
      transformResponse: (response) => {
        // console.log("Login response inside transformResponse:", response);
        return response?.data ?? null;
      },
    }),
  }),
});

export const {
  useGetOrganizationQuery,
  useLoginMutation, // ✅ This is the login hook
} = organizationApi;
